/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Dashboard_Billing_Past_CreditInputs */



/**
* | output |
* | --- |
* | "Included credit {amount}" |
*
* @param {Dashboard_Billing_Past_CreditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_past_credit = /** @type {((inputs: Dashboard_Billing_Past_CreditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Past_CreditInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Enthaltenes Guthaben ${i?.amount}`)
	return /** @type {LocalizedString} */ (`Included credit ${i?.amount}`)
});